export default function Header(){
    return (
        <header >          
            Bug Tracker
        </header>
    )
}